import { render, staticRenderFns } from "./Camera.vue?vue&type=template&id=679de8d1&scoped=true"
import script from "./Camera.vue?vue&type=script&lang=js"
export * from "./Camera.vue?vue&type=script&lang=js"
import style0 from "./Camera.vue?vue&type=style&index=0&id=679de8d1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679de8d1",
  null
  
)

export default component.exports